module.exports = __webpack_public_path__ + "static/media/lds-logo_sr.3300ee64.svg";